import React from "react";
import CircleLoader from "../../../../components/CircleLoader";
export default function Loader() {
  return (
    <div>
      <CircleLoader />
    </div>
  );
}
